import { render, staticRenderFns } from "./homePageABtest.vue?vue&type=template&id=a66979aa&"
import script from "./homePageABtest.vue?vue&type=script&lang=js&"
export * from "./homePageABtest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports